import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../../common';
export var MultiskillWarningDialog = function (_a) {
  var open = _a.open,
    onClose = _a.onClose,
    onConfirm = _a.onConfirm;
  var t = useTranslation(['wizard', 'multiSkill']).t;
  return _jsx(ConfirmDialog, {
    open: open,
    onClose: onClose,
    title: t('multiSkill:edit.warning'),
    message: t('wizard:queue.multiskillWarning'),
    onConfirm: onConfirm,
    confirmButtonText: "continue",
    cancelButtonText: "cancel"
  });
};